import { EL_SORT_STORAGE_KEY, getPersistedFilterOrder } from "components/shared/ElementList/sortStorage";
import type { TParamsPagination } from "store/types";

export const WORK_SORT_FIELD_NAMES = ["name", "createdAt", "updatedAt"] as const;

export const DEFAULT_WORK_LIST_SORT = {
    sortBy: "createdAt",
    sortOrder: "DESC",
} as const;

export const getWorksListParams = (overrides: TParamsPagination = {}): TParamsPagination => ({
    limit: 100,
    ...getPersistedFilterOrder(EL_SORT_STORAGE_KEY.works, WORK_SORT_FIELD_NAMES, DEFAULT_WORK_LIST_SORT),
    ...overrides,
});
